import { render, staticRenderFns } from "./Avintercoms.vue?vue&type=template&id=6136cba4&scoped=true&"
import script from "./Avintercoms.vue?vue&type=script&lang=js&"
export * from "./Avintercoms.vue?vue&type=script&lang=js&"
import style0 from "./Avintercoms.vue?vue&type=style&index=0&id=6136cba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6136cba4",
  null
  
)

export default component.exports